(function () {
  var SPLIT_ATTR = 'data-text-stagger';
  var STAGGER_MS = 12;

  function split(el) {
    if (el.dataset.textStaggered === 'true') return;

    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;

    el.setAttribute('aria-label', text);
    el.textContent = '';

    var front = document.createElement('span');
    front.className = 'text-stagger__layer text-stagger__layer--front';
    front.setAttribute('aria-hidden', 'true');

    var back = document.createElement('span');
    back.className = 'text-stagger__layer text-stagger__layer--back';
    back.setAttribute('aria-hidden', 'true');

    var words = text.split(' ');
    var charIndex = 0;

    words.forEach(function (word, wordIdx) {
      var wf = document.createElement('span');
      wf.className = 'text-stagger__word';
      var wb = document.createElement('span');
      wb.className = 'text-stagger__word';

      Array.from(word).forEach(function (char) {
        var cf = document.createElement('span');
        cf.className = 'text-stagger__char';
        cf.style.transitionDelay = charIndex * STAGGER_MS + 'ms';
        cf.textContent = char;
        wf.appendChild(cf);

        var cb = cf.cloneNode(true);
        wb.appendChild(cb);

        charIndex++;
      });

      front.appendChild(wf);
      back.appendChild(wb);

      if (wordIdx < words.length - 1) {
        front.appendChild(document.createTextNode(' '));
        back.appendChild(document.createTextNode(' '));
      }
    });

    el.appendChild(front);
    el.appendChild(back);
    el.dataset.textStaggered = 'true';
  }

  function init() {
    document.querySelectorAll('[' + SPLIT_ATTR + ']').forEach(split);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
